import {useNavigate, useLocation, Link, Route, Routes} from 'react-router-dom'
import React from "react";
import {ErrorBoundary} from "react-error-boundary";
import {Button} from "@mui/material";
import Participate from "./screens/frontend/Participate";
import Information from "./screens/frontend/Information";
import Privacy from "./screens/frontend/Privacy";
// import Contact from "./screens/frontend/Contact";
import QrCode from "./screens/frontend/QrCode";
import Activities from "./screens/frontend/Activities";
import Membership from "./screens/frontend/RequestMembership";
import Projects from "./screens/frontend/Projects";
import About from "./screens/frontend/About";
import ResourcesPage from './screens/frontend/ResourcesPage';
import LogoPage from './screens/frontend/LogoPage';
import BoardgamesView from './screens/frontend/Boardgames';
import Association from "./screens/frontend/Association";
import Lab from "./screens/frontend/Lab";
import PublicCuration from "./screens/frontend/PublicCuration";
import PublicSession from "./screens/frontend/PublicSession";

import '@fontsource/space-grotesk';

// import NotFound from "./screens/frontend/NotFound";
import {FrontendLayout} from './components';
import {AuthProvider} from './context/AuthProvider'
import {HelmetProvider} from 'react-helmet-async';
import {AdminMessageProvider} from './context/AdminMessageContext';
import { maybeReloadOnChunkError } from './utils/chunkReload';
import './css/frontend/frontend.css';

const Frontend = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <ErrorBoundary
            FallbackComponent={(props) => (
                <ErrorFallback
                    {...props}
                    goBack={() => {
                        props.resetErrorBoundary();
                        navigate(-1);
                    }}
                />
            )}
            onError={(error) => {
                console.error(error);
                maybeReloadOnChunkError(error);
            }}
            resetKeys={[location.pathname]}
        >
            <AdminMessageProvider>

                <AuthProvider>

                    <HelmetProvider>
                        <FrontendLayout showAdminNavigation={true}>
                            <Routes>
                                <Route path='/about' element={<About/>}/>
                                <Route path='/information' element={<Information/>}/>
                                <Route path='/association' element={<Association/>}/>
                                <Route path='/lab' element={<Lab/>}/>
                                <Route path='/projects' element={<Projects/>}/>
                                <Route path='/resources' element={<ResourcesPage/>}/>
                                <Route path='/logo' element={<LogoPage/>}/>
                                <Route path='/boardgames' element={<BoardgamesView/>}/>
                                <Route path='/memberships' element={<Membership/>}/>
                                <Route path='/activities' element={<Activities/>}/>
                                <Route path='/participate' element={<Participate/>}/>
                                <Route path='/privacy' element={<Privacy/>}/>
                                <Route path="/contact" element={<QrCode/>}/>
                                <Route path="/qrcode" element={<QrCode/>}/>
                                <Route path="/view/curations/:publicId" element={<PublicCuration/>}/>
                                <Route path="/view/curations/:publicId/p/:participantId" element={<PublicCuration/>}/>
                                <Route path="/view/sessions/:publicId" element={<PublicSession/>}/>
                                <Route path="*" element={<About/>}/>
                            </Routes>
                        </FrontendLayout>
                    </HelmetProvider>
                </AuthProvider>
            </AdminMessageProvider>
        </ErrorBoundary>
    )
}

function ErrorFallback({error, goBack}) {
    const errorMessage = error?.message || "Unknown error";
    // const isDebugMode = process.env.NODE_ENV === 'development';
    // const errorStack = error && error.stack ? error.stack : "No stack trace";

    return (

        <div className="main-user-error-message-block">
            <div className="user-error-message-block">
                <p>Something went wrong 😭</p>
                <span>Error: {errorMessage}</span>
                {/*{isDebugMode && (*/}
                {/*    <>*/}
                {/*        <p>Stack Trace:</p>*/}
                {/*        <pre>{errorStack}</pre>*/}
                {/*    </>*/}
                {/*)}*/}
                <p>-</p>
                <p>
                    <Link to={"/"} className="shop_go_to_frontend_link">
                        GO TO FRONTEND
                    </Link>
                </p>
                <p>
                    <Button onClick={goBack}>Go Back</Button>
                </p>
            </div>
        </div>
    );
}

export default Frontend
